import React from 'react'
import PropTypes from 'prop-types'

import * as Styled from './Uploader.styled'
import UploadSVG from '../../images/upload-1.svg'
import XMarkSVG from '../../images/x-mark.svg'

const UploadProgress = ({
  acceptedFiles,
  uploadProgress,
  cancelUpload,
  content,
}) => {
  return (
    <Styled.UploadingProgress>
      <Styled.FileImage src={UploadSVG} alt={content.uploading} />
      <div>
        <Styled.Uploading>{`${content.uploading} '${acceptedFiles
          ?.map((file) => file?.name)
          .join(', ')}'`}</Styled.Uploading>
        <Styled.ProgressContainer>
          <Styled.Progress>
            <Styled.ProgressBar role="progressbar" $progress={uploadProgress} />
          </Styled.Progress>
          <p>{uploadProgress}%</p>
        </Styled.ProgressContainer>
        <Styled.CancelButton onClick={cancelUpload} className="gtm-linkclick">
          <Styled.CancelImage src={XMarkSVG} alt={content.cancel} />
          <p>{content.cancel}</p>
        </Styled.CancelButton>
      </div>
    </Styled.UploadingProgress>
  )
}

UploadProgress.propTypes = {
  acceptedFiles: PropTypes.array.isRequired,
  uploadProgress: PropTypes.number.isRequired,
  cancelUpload: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
}

export default UploadProgress
